var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"status-ribbon",class:_vm.statusColor},[_vm._v(_vm._s(_vm.order.statusName))])}
var staticRenderFns = []

export { render, staticRenderFns }